import { api as axiosApi } from '../../utils/axios';

const useDocumentLibrary = () => {
    const DOCUMENT = '/api/v1/document/';
    const getFile = (id): Promise<string> => {
        return axiosApi
            .get(DOCUMENT + id, { responseType: 'blob' })
            .then((resp) => {
                return resp.data;
            })
            .catch((error) => {
                throw error;
            });
    };

    return {
        getFile,
    };
};

export default useDocumentLibrary;
